<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    ModalResponsiva(v-show="modalStatus" :usuarios="usuarios" :verBotones="verBotones" 
    :responsiva="responsivaToModal" @padre:close="cerrarModal" @borrarResponsiva="borrarResponsiva" 
    @cambiarEntrega="cambiarEntrega"
    @subirDocumentoFromResponsiva="subirDocumentoFromResponsiva"
    @borrarDocumento="verModalDeleteDocumentoFromResp" 
    )
    ModalYN(v-show="modalStatusYN" :config="configModalYN" @padre:close="borrarDocumento")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Responsivas&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-1
            a.button.is-black(:disabled='isDisabled' @click='nuevaResponsiva')
              i.fas.fa-file-signature
              | &nbspNueva
          .column.is-6(v-show='verTodos')
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='filter' checked='checked')
            label.is-size-6(for='allH')  Todos
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='filter')
            label.is-size-6(for='tpaH') TPA
            input#irgeH.is-checkradio.is-black(type='radio', value='IRGE' v-model='filter')
            label.is-size-6(for='irgeH') IRGE
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='filter')
            label.is-size-6(for='corpH') CORP.
            input#ductoH.is-checkradio.is-black(type='radio', value='DUCTO' v-model='filter')
            label.is-size-6(for='ductoH') DUCTO
          .column.is-3(:class="verTodos ? '' : 'is-offset-6'")
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Nombre de Usuario 🔎',
                  v-model="query",
                )
          .column
            a.button.is-black(@click='downloadResponsivas')
              | Descargar Responsivas&nbsp
              span.icon
                i.fas.fa-file-excel
        .columns
          .column.is-12
            TbResponsivas(:responsivas="responsivas_show" :disabled='isDisabled' @verModal="verModal")
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBar from './shared/NavBar.vue'
  import TbResponsivas from './components/TbResponsivas.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import ModalResponsiva from "./components/ModalResponsiva.vue"
  import ResponsivasService from '@/services/inventario/responsivas'
  import usuariosServices from '../../services/usuarios/usuarios'
  import InventarioServices from '../../services/inventario/inventario'
  import ModalYN from '@/components/shared/ModalYN.vue'

  import { mapState } from 'vuex'

  export default {
    name: 'Responsivas',
    components: { Loader, NavBar, flatPickr, TbResponsivas, ModalResponsiva, ModalYN },
    data() {
      return {
        isLoading: true,
        responsivas: [],
        responsivas_show: [],
        query: '',
        filter: 'ALL',
        verTodos: false,
        isDisabled: false,
        modalStatus: false,
        responsivaToModal: {},
        verBotones: false,
        usuarios: [],
        modalStatusYN: false,
        configModalYN: {},
        documentoSelect: {},
      }
    },
    watch: {
      query() {
        const QUERY_ARTICULOS = this.query.toUpperCase()
        const filtrados = this.responsivas.filter( resp => { 
          return `${resp.usuario}`.toUpperCase().includes(QUERY_ARTICULOS)
        }) 
        this.responsivas_show = filtrados
      },
      filter() {
        this.query = ''
        if (this.filter !== '') {
          if (this.filter === 'ALL') {
            this.responsivas_show 
            this.responsivas_show = this.responsivas
          } else {
            switch (this.filter) {
              case 'DUCTO':
                this.responsivas_show = this.responsivas.filter( (respon) => respon.ubicacion === 'EB00' || respon.ubicacion === 'EB01' || respon.ubicacion === 'EB02' || respon.ubicacion === 'EB03' || respon.ubicacion === 'EB04' || respon.ubicacion === 'ERM' || respon.ubicacion === 'LPG_DUCTO')
                break
              case 'TPA':
                this.responsivas_show = this.responsivas.filter( (respon) => respon.ubicacion === 'TPA')
                break
              case 'CORP':
                this.responsivas_show = this.responsivas.filter( (respon) => respon.ubicacion === 'CORP')
                break
              case 'IRGE':
                this.responsivas_show = this.responsivas.filter( (respon) => respon.ubicacion === 'IRGE')
                break
              default:
                this.responsivas_show = this.responsivas
                break
            }
            
          }
        }
      },
      tipoResponsiva () {
        this.query = ''
        if (this.filter !== '') {
          if (this.filter === 'ALL') {
            this.responsivas_show 
            let _filter = [] = this.responsivas
            if (this.tipoResponsiva !== '') {
              this.responsivas_show = _filter.filter( resp => resp.categoria == this.tipoResponsiva)
            } else {
              this.responsivas_show = _filter
            }
          } else {
            let _filter = []
            let __filter = []
            switch (this.filter) {
              case 'DUCTO':
                _filter = this.responsivas.filter( (respon) => respon.ubicacion === 'EB00' || respon.ubicacion === 'EB01' || respon.ubicacion === 'EB02' || respon.ubicacion === 'EB03' || respon.ubicacion === 'EB04' || respon.ubicacion === 'ERM' || respon.ubicacion === 'LPG_DUCTO')
                if (this.tipoResponsiva !== '') {
                  __filter = _filter.filter( resp => resp.categoria == this.tipoResponsiva)
                } else {
                  __filter = _filter
                }
                this.responsivas_show = __filter
                break
              case 'TPA':
                _filter = this.responsivas.filter( (respon) => respon.ubicacion === 'TPA')
                if (this.tipoResponsiva !== '') {
                  __filter = _filter.filter( resp => resp.categoria == this.tipoResponsiva)
                } else {
                  __filter = _filter
                }
                this.responsivas_show = __filter
                break
              case 'CORP':
                _filter = this.responsivas.filter( (respon) => respon.ubicacion === 'CORP')
                if (this.tipoResponsiva !== '') {
                  __filter = _filter.filter( resp => resp.categoria == this.tipoResponsiva)
                } else {
                  __filter = _filter
                }
                this.responsivas_show = __filter
                break
              case 'IRGE':
                _filter = this.responsivas.filter( (respon) => respon.ubicacion === 'IRGE')
                if (this.tipoResponsiva !== '') {
                  __filter = _filter.filter( resp => resp.categoria == this.tipoResponsiva)
                } else {
                  __filter = _filter
                }
                this.responsivas_show = __filter
                break
              default:
                _filter = this.responsivas
                if (this.tipoResponsiva !== '') {
                  __filter = _filter.filter( resp => resp.categoria == this.tipoResponsiva)
                } else {
                  __filter = _filter
                }
                this.responsivas_show = __filter
                break
            }
            
          }
        }
        
      }
    },
    methods: {
      iniciarComponente() {

        if (Object.keys(this.permisos).length == 0) {
          this.verTodos = false
          this.isDisabled = true
          this.verBotones = false
          return
        }

        switch (this.permisos.responsivas) {
          case 1:
            this.verTodos = true
            this.isDisabled = false
            this.verBotones = true
            break
          case 2:
            this.verTodos = false
            this.isDisabled = true
            this.verBotones = false
            break
          case 3:
            this.verTodos = true
            this.isDisabled = true
            this.verBotones = false
            break
          case 4:
            this.verTodos = false
            this.isDisabled = true
            this.verBotones = false
            break
          case 5:
            this.verTodos = false
            this.isDisabled = false
            this.verBotones = true
            break
          case 6:
            this.verTodos = true
            this.isDisabled = false
            this.verBotones = true
            break
          default:
            this.verTodos = false
            this.isDisabled = true
            this.verBotones = false
            break
        }
        this.obtenerUsuarios()
      },

      obtenerUsuarios () {
        if (this.permisos.responsivas == 2) {
          return
        }

        if (this.permisos.responsivas == 1 || this.permisos.responsivas == 6) {
          usuariosServices.getUsuarios()
            .then( (res) => {
                if (res.length > 0) {
                  const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
                  this.usuarios = usersSort.map(this.convertirDataUsuarios)
                  this.getResponsivas()
                } else {
                  this.displayToast('No hay datos', 'ban', 'OK')
                  this.isLoading = false
                }  
              })
              .catch((error) => {
                this.isLoading = false
                this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
              })
          return
        }

        if (this.permisos.responsivas == 5) {
          usuariosServices.getUsuarios_Ubicacion(this.userLogin.ubicacion)
            .then( (res) => {
              const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
              this.usuarios = usersSort.map(this.convertirDataUsuarios)
              this.getResponsivas()
            })
            .catch((e) => {
              this.displayToast(e.message, 'ban', 'OK')
            })
          return
        }

        if (this.permisos.responsivas == 7) {
          usuariosServices.getUsuarios_SeI()
            .then( (res) => {
              if (res.length > 0) {
                const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
                this.usuarios = usersSort.map(this.convertirDataUsuarios)
                this.getResponsivas()
              } else {
                this.displayToast('No hay datos', 'ban', 'OK')
                this.isLoading = false
              }  
            })
            .catch((error) => {
              this.isLoading = false
              this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
            })
          return
        }

        if (this.permisos.responsivas == 8) {
          usuariosServices.getUsuarios_Ducto()
            .then( (res) => {
              if (res.length > 0) {
                const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
                this.usuarios = usersSort.map(this.convertirDataUsuarios)
                this.getResponsivas()
              } else {
                this.displayToast('No hay datos', 'ban', 'OK')
                this.isLoading = false
              }  
            })
            .catch((error) => {
              this.isLoading = false
              this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
            })
          return
        }
      },

      convertirDataUsuarios(user) {
        return {
          ...user,
          categoria: parseInt(user.categoria),
          departamento: parseInt(user.departamento),
          jefeArea: parseInt(user.jefeArea)
        }
      },
      
      getResponsivas() {
        let ubi = ''
        if (this.verTodos) {
          ubi = 'ALL'
        } else {
          ubi = this.userLogin.ubicacion
        }

        ResponsivasService.getResponsivas_users(ubi, this.userLogin.departamento)
          .then( dataResp => {
            this.responsivas = dataResp.map(this.convetirData)
            this.responsivas_show = this.responsivas
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            console.log(e)
          })
      },
      
      convetirData(resp) {
        const respons = resp.responsivas.map(this.convetirToIntResp)
        return {
          ...resp,
          responsivas: respons
        }
      },
      
      convetirToIntResp (obj) {
        const doctos = obj.documentos.map(this.convetirDocumentos)
        return {
          ...obj,
          categoria: parseInt(obj.categoria),
          estado: parseInt(obj.estado),
          id: parseInt(obj.id),
          tipo: parseInt(obj.tipo),
          doctos,
        }
      },

      convetirDocumentos(obj) {
        return {
          ...obj,
          id: Number(obj.id),
          tipo: Number(obj.tipo),
        }
      },

      nuevaResponsiva() {
        if (!this.isDisabled) {
          this.$router.push('/Responsivas/Nueva')
        }
      },
      
      downloadResponsivas () {
        this.isLoading = true
        ResponsivasService.createExcelResponsivas()
          .then( data => {
            if (data.success) {
              const currentUrl = window.location.hostname
              open(`https://${currentUrl}/reportesApp/server/excel/generarResguardo_All.php?nameFile=${data.file}`, '_blank')
              setTimeout(() => {
                InventarioServices.borrarFile_InventarioUser(data.file)
                  .then( resDel => {
                    this.isLoading = false
                    console.log(resDel)
                  })
              }, 4000)
            } else {
              this.displayToast('bubble', 'No se pudo descargar el archivo.', 'ban', 'OK')
            }
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble', e.message, 'ban', 'OK')
          })
      },
      
      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      
      verModal (responsiva) {
        let dataResponsiva = []
        switch (responsiva.categoria) {
          case 0:
            ResponsivasService.getItems_Multiples(responsiva.nombre_responsiva)
              .then( data => {
                dataResponsiva = data
                this.responsivaToModal = this.crearObjResponsivaModal(responsiva, dataResponsiva)
                this.modalStatus = true
              })
              .catch(e => {
                this.displayToast('bubble', e.message, 'ban', 'OK')
              })
            break
          case 1:
            ResponsivasService.getItems_Computo(responsiva.nombre_responsiva)
              .then( data => {
                dataResponsiva = data
                this.responsivaToModal = this.crearObjResponsivaModal(responsiva, dataResponsiva)
                this.modalStatus = true
              })
              .catch(e => {
                this.displayToast('bubble',e.message, 'ban', 'OK')
              })
            break
          case 2:
            ResponsivasService.getItems_Telefono(responsiva.nombre_responsiva)
              .then( data => {
                dataResponsiva = data
                this.responsivaToModal = this.crearObjResponsivaModal(responsiva, dataResponsiva)
                this.modalStatus = true
              })
              .catch(e => {
                this.displayToast('bubble', e.message, 'ban', 'OK')
              })
            break
          case 3:
            ResponsivasService.getItems_Combustible(responsiva.nombre_responsiva)
              .then( data => {
                dataResponsiva = data
                this.responsivaToModal = this.crearObjResponsivaModal(responsiva, dataResponsiva)
                this.modalStatus = true
              })
              .catch(e => {
                this.displayToast('bubble', e.message, 'ban', 'OK')
              })
            break
          case 4:
            ResponsivasService.getItems_Peaje(responsiva.nombre_responsiva)
              .then( data => {
                dataResponsiva = data
                this.responsivaToModal = this.crearObjResponsivaModal(responsiva, dataResponsiva)
                this.modalStatus = true
              })
              .catch(e => {
                this.displayToast('bubble', e.message, 'ban', 'OK')
              })
            break
          case 5:
            ResponsivasService.getItems_Vehiculos(responsiva.nombre_responsiva)
              .then( data => {
                dataResponsiva = data
                this.responsivaToModal = this.crearObjResponsivaModal(responsiva, dataResponsiva)
                this.modalStatus = true
              })
              .catch(e => {
                this.displayToast('bubble', e.message, 'ban', 'OK')
              })
            break
        
          default:
            dataResponsiva = []
            this.responsivaToModal = this.crearObjResponsivaModal(responsiva, dataResponsiva)
            this.modalStatus = true
            break
        }
      },

      crearObjResponsivaModal (resp, items) {
        return {
          ...resp,
          items: items
        }
      },

      borrarResponsiva (resp) {
        ResponsivasService.borrarResponsiva(resp.id)
          .then( data => {
            this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
            this.getResponsivas()
            this.modalStatus = false
          })
          .catch(e => {
            this.displayToast('bubble', e.message, 'ban', 'OK')
          })
      },

      cerrarModal () {
        this.responsivaToModal = {}
        this.modalStatus = false
      },

      backPage() {
        this.$router.back()
      },

      cambiarEntrega(user) {
        if (Object.keys(user).length > 0) {
          ResponsivasService.updateEntregaResponsiva(this.responsivaToModal.id, user.id, user.nombre)
            .then( res => {
              this.displayToast(res.success ? 'toasted-primary' : 'bubble', res.respuesta, res.success ? 'done' : 'ban', 'OK')
              this.getResponsivas()
              this.modalStatus = false
            })
            .catch( e => {
              this.displayToast('bubble', e.message, 'ban', 'OK')
            })
        }
      },
      subirDocumentoFromResponsiva (objResp) {
        this.modalStatus = false
        this.isLoading = true
        const { files } = objResp
        const filesD = Array.from(files)
        if (filesD.length > 0) {
          filesD.forEach(docto => {
            const nombreFile = docto.name

            InventarioServices.uploadDocumento(this.responsivaToModal.id_articulo, nombreFile, docto, objResp.tipo)
              .then(data => {
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                this.responsivaToModal = {}
                this.iniciarComponente()
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          })
        } else {
          this.displayToast('bubble', 'No hay documentos seleccionadas', 'ban', 'OK')
          this.isLoading = false
        }
      },
      verModalDeleteDocumentoFromResp (docto) {
        if (this.permisos.inventarios == 6) {
          return
        }
        this.configModalYN = {
          title: '¿Desea borrar el documento?',
          content: 'Borrar documento de la responsiva.',
          textCancel: 'Cancelar',
          textOk: 'Eliminar'
        }
        this.modalStatus = false
        this.documentoSelect = docto
        this.modalStatusYN = true
        this.isFileResponsiva = true
      },

      borrarDocumento (result) {
        this.modalStatusYN = false
        this.isLoading = true
        if (result) {
          if (!this.isFileResponsiva) {
            if (this.documentoSelect.tipo === 'documento') {
              InventarioServices.deleteDocumento(this.documentoSelect.id, this.documentoSelect.ruta)
                .then(data => {
                  this.iniciarComponente()
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                })
                .catch( error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })
            } else {
              InventarioServices.deleteFactura(this.documentoSelect.id_articulo, this.documentoSelect.rutaFac)
                .then(data => {
                  this.iniciarComponente()
                  this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
                })
                .catch( error => {
                  this.isLoading = false
                  this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
                })
            }
          } else {
            InventarioServices.deleteDocumento(this.documentoSelect.id, this.documentoSelect.ruta)
              .then(data => {
                this.iniciarComponente()
                this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'Ok')
              })
              .catch( error => {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${error.message}`, 'ban', 'Ok')
              })
          }
        } else {
          this.isLoading = false
          this.modalStatusD = true
        }
        this.documentoSelect = {}
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
    },
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/Responsivas.vue